// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"145":"0ee88c06","554":"ca3e8b26","590":"719fab35","686":"144fc61f"}[chunkId] + ".chunk.js";
};